import { createSlice } from "@reduxjs/toolkit";
import formateErrorsContent from "../../../utils/formatErrorsContent";

const messageSlice = createSlice({
    // TODO: Move to UI Slice as Toast
    name: "messages",
    initialState: {
        title: null,
        content: null,
        isShown: false,
        isError: false,
    },

    reducers: {
        setMessage: (state, { payload }) => {
            const { title, content, isError } = payload;
            state.title = title;
            state.content = isError ? formateErrorsContent(content) : content;
            state.isError = isError;
            state.isShown = true;
        },
        removeMessage: (state) => {
            state.title = null;
            state.content = null;
            state.isShown = false;
            state.isError = false;
        },
    },
});

export default messageSlice.reducer;

export const { setMessage, removeMessage } = messageSlice.actions;
export const messageSelector = (state) => state.messages;
